import { NgModule } from '@angular/core';
import { CommonModule, APP_BASE_HREF } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

// Import vendor modules
import { NgxPopperModule } from 'ngx-popper';

import { CoreModule } from '../core';
import { SharedModule } from '../shared';
import { UIModule } from '../ui.module';
import { PowerRoutingModule } from './power.routing';

// Module's pages components.
import { BaseComponent } from './base/base.component';
import { CreepToolComponent } from './creep-tool/creep-tool.component';
import { CreepsComponent } from './creeps/creeps.component';
import { PowerCreepsAvailableComponent } from './power-creeps-available';

// Module's components.
import { CreepComponent } from './creep/creep.component';
import { CreepTypesComponent } from './creep-types/creep-types.component';
import { PowerComponent } from './power/power.component';
import { CommanderComponent } from './commander.component';
import { OperatorComponent } from './operator.component';
import { ExecutorComponent } from './executor.component';
import { LevelToolComponent } from './level-tool/level-tool.component';
import { PowerInfoComponent } from './power-info/power-info.component';

// Modules's providers.
import { CreepsService } from './creeps.service';
import { CreepsResolver } from './creeps.resolver';

// Module's pipes.
import { PowerIconPipe } from './power-icon.pipe';
import { PowerNamePipe } from './power-name.pipe';
import { PowerLevelPipe } from './power-level.pipe';
import { PowersKeysPipe } from './powers-keys.pipe';
import { CreepNameFieldComponent } from './creep-name-field/creep-name-field.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,

        NgxPopperModule.forRoot({
            disableDefaultStyling: true,
            placement: 'bottom',
            appendTo: 'body'
        }),

        CoreModule,
        SharedModule,
        UIModule,

        PowerRoutingModule
    ],
    declarations: [
        BaseComponent,
        CreepToolComponent,
        CreepsComponent,
        PowerCreepsAvailableComponent,

        CreepComponent,
        CreepTypesComponent,
        PowerComponent,

        CommanderComponent,
        OperatorComponent,
        ExecutorComponent,
        LevelToolComponent,
        PowerInfoComponent,

        PowerIconPipe,
        PowerNamePipe,
        PowerLevelPipe,
        PowersKeysPipe,
        CreepNameFieldComponent
    ],
    providers: [
        CreepsService,
        CreepsResolver
    ]
})
export class PowerModule { }
